import React, { useState } from "react";
import Header from "@commons/header";
import Row from "@components/row";
import Column from "@components/column";
import Fields from "@components/fields";
import Button from "@components/button";
import ButtonWrapper from "@components/wrapper/button-wrapper";
import { Formik, Form } from "formik";
import Typography from "@components/typography";
import Wrapper from "@components/wrapper";
import FieldWrapper from "@components/wrapper/field-wrapper";

const MetaData = () => {
  const [preview, setPreview] = useState<string | null>(null);

  const initialValues = {
    metaTitle: "",
    metaKeyword: "",
    metaDescription: "",
    metaImage: null,
  };

  const handleSubmit = (values: any, { resetForm }: any) => {
    console.log("Meta data submitted:", values);
    resetForm();
    setPreview(null);
  };

  const handleImageChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: any
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      setFieldValue("metaImage", file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {({ handleReset, setFieldValue }) => (
        <Form>
          <Header title="Meta Data" />
          <br />
          <FieldWrapper>
            <Column>
              <Row>
                <div style={{ flex: 3 }}>
                  <Column>
                    <Fields.Input
                      name="metaTitle"
                      label="Meta Title"
                      placeholder="Enter meta title"
                    />

                    <Fields.Input
                      name="metaKeyword"
                      label="Meta Keywords"
                      placeholder="e.g. travel, tourism, japan"
                    />

                    <Fields.TextArea
                      name="metaDescription"
                      label="Meta Description"
                      placeholder="Write a brief meta description"
                    />
                  </Column>
                </div>
                <div style={{ flex: 1 }}>
                  <Fields.Upload name="metaImage" />
                </div>
              </Row>

              <ButtonWrapper>
                <Button
                  type="reset"
                  variant="reset"
                  title="Reset"
                  onClick={handleReset}
                />
                <Button type="submit" title="Save" />
              </ButtonWrapper>
            </Column>
          </FieldWrapper>
        </Form>
      )}
    </Formik>
  );
};

export default MetaData;
